import api from './client';

// Dashboard API
export const dashboardAPI = {
  getSummary: (entityId, { scope } = {}) => api.get('/dashboard/summary', { params: { entity_id: entityId, scope } }),
  getCashflow: (entityId, days = 30, { scope } = {}) => api.get('/dashboard/cashflow', { params: { entity_id: entityId, days, scope } }),
  getFxExposure: (entityId, { scope } = {}) => api.get('/dashboard/fx-exposure', { params: { entity_id: entityId, scope } }),
  getCashRunway: (entityId, { scope, calendarYear } = {}) =>
    api.get('/dashboard/cash-runway', { params: { entity_id: entityId, scope, calendar_year: calendarYear } }),
};

// Forecast API (forward bookings)
export const forecastAPI = {
  get: (params) => api.get('/reports/forecast', { params }),
};

// Per-bank monthly balance history (single-entity dashboard, redesign step 4;
// scope param added for the All Entities/All Personal aggregate dashboards;
// scope='group' added for the Overall dashboard's per-bank Bank Balance chart)
export const bankBalanceHistoryAPI = {
  get: (entityId, { months, displayCurrency, scope } = {}) =>
    api.get('/reports/entity/bank-balance-history', {
      params: { entity_id: entityId, scope, months, display_currency: displayCurrency },
    }),
};

// Group Dashboard API
export const groupDashboardAPI = {
  get: (params) => api.get('/reports/group', { params, timeout: 60000 }),
  refresh: () => api.post('/reports/group/refresh'),
  refreshStatus: (jobId) => api.get(`/reports/group/refresh/${jobId}`),
};

// Attention (Findings) API
export const attentionAPI = {
  getFindings: (params) => api.get('/attention/findings', { params, timeout: 30000 }),
  getBadge: () => api.get('/attention/badge', { timeout: 10000 }),
  getDigest: () => api.get('/attention/digest', { timeout: 30000 }),
  runChecks: () => api.post('/attention/run', null, { timeout: 300000 }),
};

// Control page API
export const controlAPI = {
  getSummary: (refresh = false) => api.get('/control/summary', { params: { refresh }, timeout: 300000 }),
};

// Group Cash Forecast API
export const groupForecastAPI = {
  get: () => api.get('/forecast/group-cash', { timeout: 60000 }),
};
